import React from 'react'
import TableSousCatégorie from '../../Components/table/TableSousCategorie'

const SousCatégorie = () => {
  return <TableSousCatégorie />
}

export default SousCatégorie
